import { render, staticRenderFns } from "./AuthFormSecondaryLink.vue?vue&type=template&id=2e3ef27e&scoped=true&"
import script from "./AuthFormSecondaryLink.vue?vue&type=script&lang=js&"
export * from "./AuthFormSecondaryLink.vue?vue&type=script&lang=js&"
import style0 from "./AuthFormSecondaryLink.vue?vue&type=style&index=0&id=2e3ef27e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ef27e",
  null
  
)

export default component.exports